import { ILoginPayload } from 'ts/login/interfaces';
import auth0 from 'ts/login/services/auth0';
import { AxiosResponse } from 'axios';
import { UserServiceResponse } from 'ts/passwordless-login/services/user/UserServiceResponse';
import { lookupLoginUserWithCaptcha } from 'ts/passwordless-login/services/user/UserService';

export const login = async (username: string, password: string, rememberMe: boolean) => {
  const payload: ILoginPayload = {
    password,
    rememberMe,
    username,
  };

  return auth0.authenticate(payload).catch((errorCode: string) => {
    throw new Error(errorCode);
  });
};

export const userExistsInAuth0 = async (username: string): Promise<boolean> => {
  const response: AxiosResponse<[UserServiceResponse]> = await lookupLoginUserWithCaptcha(username);
  if (response && response.data.length === 0) {
    return Promise.resolve(false);
  } else {
    return Promise.resolve(true);
  }
};
